module.exports = __webpack_public_path__ + "img/five.a5a4d344.png";